import {useDispatch} from 'react-redux';

import {WikiDispatch} from '~ui/store';

export const useAppDispatch = () => useDispatch<WikiDispatch>();
